import React from 'react';
import CookieBanner from './CookieBanner';
import CookiePreferencesModal from './CookiePreferencesModal';

/** Mount once at app root: banner on first visit + preferences modal. */
const CookieConsentManager: React.FC = () => {
  return (
    <>
      <CookieBanner />
      <CookiePreferencesModal />
    </>
  );
};

export default CookieConsentManager;
